const { path } = require('ramda')

function Currency(val, locale = 'nb', currency = 'NOK', decimals = 0) {
  if ([null, undefined].includes(val)) return
  return val.toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
  })
}

function getDimensions(url) {
  return new Promise((resolve, reject) => {
    if (!url) return reject(new Error('Url is required'))
    let img = new Image()
    img.onload = function () {
      resolve({
        width: img.width,
        height: img.height,
      })
    }
    img.onerror = reject
    img.src = url
  })
}

function Limit(val, limit = 30) {
  if (val.length < limit) return val
  return `${val.substr(0, limit)}...`
}

function StripHtml(html) {
  let tmp = document.createElement('div')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

function CheckConditions(item, selectedItems) {
  if (!item || !item.conditions) return true

  let ids = selectedItems.map(s => s.id)

  if (item.conditions.if.length) return item.conditions.if.some(id => ids.includes(id))
  if (item.conditions.ifnot.length) return item.conditions.ifnot.every(id => !ids.includes(id))

  return true
}

function ConditionFilter(value, selected) {
  // Category handler
  if (value.categories) {
    let children = value.categories.filter(subcat => CheckConditions(subcat, selected))
    if (!children.length) return
  }

  return CheckConditions(value, selected)
}

function getConditionalDependencies(id, data) {
  const getConditions = (v, k) => path(['conditions', k], v) || []
  const ValueOrDefault = (v, d) => v || d

  let ifs = new Set()
  let ifnots = new Set()

  ValueOrDefault(data.categories, []).forEach(category => {
    let cif = getConditions(category, 'if').includes(id)
    let cifn = getConditions(category, 'ifnot').includes(id)

    if (cif) ifs.add(category.id)
    if (cifn) ifnots.add(category.id)

    ValueOrDefault(category.categories, []).forEach(subcategory => {
      let scif = getConditions(subcategory, 'if').includes(id)
      let scifn = getConditions(subcategory, 'ifnot').includes(id)

      if (cif || scif) ifs.add(subcategory.id)
      if (cifn || scifn) ifnots.add(subcategory.id)

      ValueOrDefault(subcategory.items, []).forEach(item => {
        if (cif || scif || getConditions(item, 'if').includes(id)) ifs.add(item.id)
        if (cifn || scifn || getConditions(item, 'ifnot').includes(id)) ifnots.add(item.id)
      })
    })
  })

  return {
    if: Array.from(ifs),
    ifnot: Array.from(ifnots),
  }
}

export {
  Currency,
  Limit,
  StripHtml,
  CheckConditions,
  getConditionalDependencies,
  ConditionFilter,
  getDimensions,
}
